export default "__VITE_ASSET__DyqcgguX__"